import { Blockchain } from "@rarible/api-client"
import { electroneum } from "viem/chains"
import { toCurrencyId } from "../../../price/types"
import { FEE_CONFIG_URL } from "../constants"
import type { StaticEthereumBlockchainConfig } from "../types"

export const electroneumConfig: StaticEthereumBlockchainConfig = {
  name: "Electroneum",
  icon: "/images/blockchains/electroneum.svg",
  isEvm: true,
  testnet: false,
  isTestnet: false,
  feesVersion: "v3",
  treasury: "0x64d34BcfC32Fb663172C47d6E4Fb1dBFaba6e7a2",
  unionApi: "https://api.rarible.org",
  basePath: "https://electroneum-api.rarible.org",
  chainId: electroneum.id,
  blockchain: Blockchain.ELECTRONEUM,
  chainName: electroneum.name,
  exchange: {
    v2: "0x2c46e116a742C159fa79e2717b50759EC979e3Be",
    wrapper: "0x2E89636Ba21C35d250E8Db5E414D751FbBdCE444",
  },
  blockExplorers: [
    {
      url: "https://blockexplorer.electroneum.com",
      icon: "/images/scanner.svg",
      adress: "https://blockexplorer.electroneum.com/address/${adrress}",
    },
  ],
  rpcUrls: [
    {
      url: "https://rpc.electroneum.com",
      isPublic: true,
    },
  ],
  transferProxies: {
    nft: "0x892f0e3DEaC041b12b748bf9d7D1BA480d266696",
    erc721Lazy: "0x147d06FbDA085C0455615E554D87262B0726ad0c",
    erc20: "0x12181eDedD1f81838580668bb5B50e1030df4667",
  },
  feeConfigUrl: FEE_CONFIG_URL,
  primaryCurrency: {
    id: toCurrencyId("ELECTRONEUM:0x0000000000000000000000000000000000000000"),
    symbol: "ETN",
    name: "Electroneum",
    decimals: 18,
  },
  wrappedCurrency: {
    id: toCurrencyId("ELECTRONEUM:0x138dafbda0ccb3d8e39c19edb0510fc31b7c1c77"),
    symbol: "WETN",
    name: "Wrapped Electroneum",
    decimals: 18,
  },
  addFundsLink: "https://bridge.umbria.network/",
  hasStabilityProtocol: true,
  viem: electroneum,
}

export const getElectroneumConfig = (): StaticEthereumBlockchainConfig =>
  electroneumConfig
